// Recovered compiled webpack factory 98156. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getNamedMiddlewareRegex: function () {
        return p;
      },
      getNamedRouteRegex: function () {
        return d;
      },
      getRouteRegex: function () {
        return u;
      },
    }));
  let n = r(16832),
    a = r(57630),
    o = r(13314),
    i = r(77700),
    s = r(25403);
  function l(e, t, r) {
    let n = {},
      l = 1,
      u = [];
    for (let c of (0, i.removeTrailingSlash)(e).slice(1).split("/")) {
      let e = a.INTERCEPTION_ROUTE_MARKERS.find((e) => c.startsWith(e)),
        i = c.match(s.PARAMETER_PATTERN);
      if (e && i && i[2]) {
        let { key: t, optional: r, repeat: a } = (0, s.parseMatchedParameter)(i[2]);
        ((n[t] = { pos: l++, repeat: a, optional: r }),
          u.push("/" + (0, o.escapeStringRegexp)(e) + "([^/]+?)"));
      } else if (i && i[2]) {
        let { key: e, repeat: t, optional: a } = (0, s.parseMatchedParameter)(i[2]);
        ((n[e] = { pos: l++, repeat: t, optional: a }),
          r && i[1] && u.push("/" + (0, o.escapeStringRegexp)(i[1])));
        let c = t ? (a ? "(?:/(.+?))?" : "/(.+?)") : "/([^/]+?)";
        (r && i[1] && (c = c.substring(1)), u.push(c));
      } else u.push("/" + (0, o.escapeStringRegexp)(c));
      t && i && i[3] && u.push((0, o.escapeStringRegexp)(i[3]));
    }
    return { parameterizedRoute: u.join(""), groups: n };
  }
  function u(e, t) {
    let {
        includeSuffix: r = !1,
        includePrefix: n = !1,
        excludeOptionalTrailingSlash: a = !1,
      } = void 0 === t ? {} : t,
      { parameterizedRoute: o, groups: i } = l(e, r, n),
      s = o;
    return (a || (s += "(?:/)?"), { re: RegExp("^" + s + "$"), groups: i });
  }
  function c(e) {
    let t,
      {
        interceptionMarker: r,
        getSafeRouteKey: n,
        segment: a,
        routeKeys: i,
        keyPrefix: l,
        backreferenceDuplicateKeys: u,
      } = e,
      { key: c, optional: f, repeat: d } = (0, s.parseMatchedParameter)(a),
      p = c.replace(/\W/g, "");
    l && (p = "" + l + p);
    let h = !1;
    ((0 === p.length || p.length > 30) && (h = !0),
      isNaN(parseInt(p.slice(0, 1))) || (h = !0),
      h && (p = n()));
    let _ = p in i;
    l ? (i[p] = "" + l + c) : (i[p] = c);
    let m = r ? (0, o.escapeStringRegexp)(r) : "";
    return (
      (t = _ && u ? "\\k<" + p + ">" : d ? "(?<" + p + ">.+?)" : "(?<" + p + ">[^/]+?)"),
      f ? "(?:/" + m + t + ")?" : "/" + m + t
    );
  }
  function f(e, t, r, l, u) {
    let f,
      d =
        ((f = 0),
        () => {
          let e = "",
            t = ++f;
          for (; t > 0; )
            ((e += String.fromCharCode(97 + ((t - 1) % 26))), (t = Math.floor((t - 1) / 26)));
          return e;
        }),
      p = {},
      h = [];
    for (let f of (0, i.removeTrailingSlash)(e).slice(1).split("/")) {
      let e = a.INTERCEPTION_ROUTE_MARKERS.some((e) => f.startsWith(e)),
        i = f.match(s.PARAMETER_PATTERN);
      if (e && i && i[2])
        h.push(
          c({
            getSafeRouteKey: d,
            interceptionMarker: i[1],
            segment: i[2],
            routeKeys: p,
            keyPrefix: t ? n.NEXT_INTERCEPTION_MARKER_PREFIX : void 0,
            backreferenceDuplicateKeys: u,
          }),
        );
      else if (i && i[2]) {
        l && i[1] && h.push("/" + (0, o.escapeStringRegexp)(i[1]));
        let e = c({
          getSafeRouteKey: d,
          segment: i[2],
          routeKeys: p,
          keyPrefix: t ? n.NEXT_QUERY_PARAM_PREFIX : void 0,
          backreferenceDuplicateKeys: u,
        });
        (l && i[1] && (e = e.substring(1)), h.push(e));
      } else h.push("/" + (0, o.escapeStringRegexp)(f));
      r && i && i[3] && h.push((0, o.escapeStringRegexp)(i[3]));
    }
    return { namedParameterizedRoute: h.join(""), routeKeys: p };
  }
  function d(e, t) {
    var r, n, a;
    let o = f(
        e,
        t.prefixRouteKeys,
        null != (r = t.includeSuffix) && r,
        null != (n = t.includePrefix) && n,
        null != (a = t.backreferenceDuplicateKeys) && a,
      ),
      i = o.namedParameterizedRoute;
    return (
      t.excludeOptionalTrailingSlash || (i += "(?:/)?"),
      { ...u(e, t), namedRegex: "^" + i + "$", routeKeys: o.routeKeys }
    );
  }
  function p(e, t) {
    let { parameterizedRoute: r } = l(e, !1, !1),
      { catchAll: n = !0 } = t;
    if ("/" === r) return { namedRegex: "^/" + (n ? ".*" : "") + "$" };
    let { namedParameterizedRoute: a } = f(e, !1, !1, !1, !1);
    return { namedRegex: "^" + a + (n ? "(?:(/.*)?)" : "") + "$" };
  }
}
